import auth from "astrid-firebase/src/auth";
import createStore from "astrid-helpers/src/createStore";

export const [getUser, setUser, useUser, onUser, resetUser] = createStore();

auth.onAuthStateChanged(setUser);
